var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-switch',{attrs:{"label":_vm.option.name,"loading":_vm.loading},model:{value:(_vm.option.selectedOptions),callback:function ($$v) {_vm.$set(_vm.option, "selectedOptions", $$v)},expression:"option.selectedOptions"}}),_vm._v(" "),(_vm.option.hint)?_c('div',{staticClass:"text-muted"},[_vm._v(_vm._s(_vm.option.hint))]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }